import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { NikoFacilityOrderInitialIntakePreviewViewStore } from "../stores";
import { NikoFacilityOrderInitialIntakePreviewTemplate } from "themes/application/niko-facility-order-initial-intake/pages";

@setCurrentView(rootStore => new NikoFacilityOrderInitialIntakePreviewViewStore(rootStore), "nikoFacilityOrderInitialIntakePreviewViewStore")
@observer
class NikoFacilityOrderInitialIntakePreview extends React.Component {
	render() {
		return <NikoFacilityOrderInitialIntakePreviewTemplate {...this.props} />;
	}
}

export default NikoFacilityOrderInitialIntakePreview;